/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ method: NonNullable<unknown>, date: NonNullable<unknown> }} Body_Assessment_Anchor_SummaryInputs */

const en_us2_body_assessment_anchor_summary = /** @type {(inputs: Body_Assessment_Anchor_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.method}, entered on ${i?.date}.`)
};

const pt_br2_body_assessment_anchor_summary = /** @type {(inputs: Body_Assessment_Anchor_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.method}, informada em ${i?.date}.`)
};

const es_419_body_assessment_anchor_summary = /** @type {(inputs: Body_Assessment_Anchor_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.method}, ingresada el ${i?.date}.`)
};

const pt_pt2_body_assessment_anchor_summary = /** @type {(inputs: Body_Assessment_Anchor_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.method}, indicada em ${i?.date}.`)
};

const fr_fr2_body_assessment_anchor_summary = /** @type {(inputs: Body_Assessment_Anchor_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.method}, saisie le ${i?.date}.`)
};

const de_de2_body_assessment_anchor_summary = /** @type {(inputs: Body_Assessment_Anchor_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.method}, eingetragen am ${i?.date}.`)
};

const it_it2_body_assessment_anchor_summary = /** @type {(inputs: Body_Assessment_Anchor_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.method}, inserita il ${i?.date}.`)
};

/**
* | output |
* | --- |
* | "{method}, entered on {date}." |
*
* @param {Body_Assessment_Anchor_SummaryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_anchor_summary = /** @type {((inputs: Body_Assessment_Anchor_SummaryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Anchor_SummaryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_anchor_summary(inputs)
	if (locale === "es-419") return es_419_body_assessment_anchor_summary(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_anchor_summary(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_anchor_summary(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_anchor_summary(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_anchor_summary(inputs)
	return en_us2_body_assessment_anchor_summary(inputs)
});
export { body_assessment_anchor_summary as "body-assessment.anchor_summary" }